export const travelSafetyFeaturesList = [
    {
        id: '1',
        title: 'Live Location Sharing',
        content: "Explore with confidence. Share your real-time location with select contacts so they can see where you are without constant check-ins.",
        imgName: 'locationSharingCarousell'
    },
    {
        id: '2',
        title: 'Emergency Alert',
        content: 'f you ever feel unsafe, send an instant emergency alert to your chosen contacts with your precise location. Ideal for solo travellers who need a quick way to call for help.',
        imgName: 'newEmergencyAlertCaousell'
    },
    {
        id: '3',
        title: 'Check-In Feature',
        content: 'A simple tap lets your family or friends know you’ve arrived safely at your destination. Perfect for checking in after long journeys or remote excursions.',
        imgName: 'checkInCarousel'
    },
    {
        id: '5',
        title: 'Instant Messaging',
        content: "No need to switch between multiple apps, stay in touch with your travel companions and loved ones directly within Device Tracker Plus.",
        imgName: 'messegesCarousel'
    },
];